import React, { useState } from 'react';
import axios from 'axios';

const ConnectionTab = ({ connectionStatus, onStatusChange, showToast }) => {
  const [formData, setFormData] = useState({
    access_token: '',
    ad_account_id: '',
    account_name: '',
    page_id: ''
  });
  const [loading, setLoading] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [editingPageId, setEditingPageId] = useState(false);
  const [pageIdInput, setPageIdInput] = useState('');
  const [savingPageId, setSavingPageId] = useState(false);

  const handleConnect = async (e) => {
    e.preventDefault();
    if (!formData.access_token || !formData.ad_account_id) {
      return showToast('Access Token ve Ad Account ID zorunludur', 'warning');
    }

    setLoading(true);
    try {
      await axios.post('/api/meta/connect', formData, {
        headers: { Authorization: `Bearer ${localStorage.getItem('crm_token')}` }
      });
      showToast('Meta hesabı başarıyla bağlandı!', 'success');
      onStatusChange();
    } catch (err) {
      console.error(err);
      showToast(err.response?.data?.error || 'Bağlantı hatası', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleDisconnect = async () => {
    if (!window.confirm('Meta hesabınızın bağlantısını kesmek istediğinize emin misiniz? (Tüm senkronize edilmiş reklam verileriniz de silinecektir)')) return;

    setLoading(true);
    try {
      await axios.delete('/api/meta/disconnect', {
        headers: { Authorization: `Bearer ${localStorage.getItem('crm_token')}` }
      });
      showToast('Bağlantı kesildi', 'success');
      onStatusChange();
    } catch (err) {
      console.error(err);
      showToast('Hata oluştu', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleSync = async () => {
    setSyncing(true);
    try {
      await axios.post('/api/meta/sync', {}, {
        headers: { Authorization: `Bearer ${localStorage.getItem('crm_token')}` }
      });
      showToast('Senkronizasyon tamamlandı', 'success');
      onStatusChange();
    } catch (err) {
      console.error(err);
      showToast(err.response?.data?.error || 'Senkronizasyon başarısız', 'error');
      onStatusChange(); // toast kaybolsa da hata "Son Senkronizasyon Hatası" bannerında kalsın diye yeni durumu hemen çek
    } finally {
      setSyncing(false);
    }
  };

  const startEditPageId = () => {
    setPageIdInput(connectionStatus.page_id || '');
    setEditingPageId(true);
  };

  const savePageId = async () => {
    if (!pageIdInput.trim()) return showToast('Facebook Page ID boş olamaz', 'warning');
    setSavingPageId(true);
    try {
      await axios.put('/api/meta/page-id', { page_id: pageIdInput.trim() }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('crm_token')}` }
      });
      showToast('Page ID güncellendi', 'success');
      setEditingPageId(false);
      onStatusChange();
    } catch (err) {
      console.error(err);
      showToast(err.response?.data?.error || 'Güncelleme başarısız', 'error');
    } finally {
      setSavingPageId(false);
    }
  };

  const copyWebhook = () => {
    const url = `${window.location.origin}/api/meta/webhook`;
    navigator.clipboard.writeText(url);
    showToast('Webhook URL kopyalandı', 'success');
  };

  if (connectionStatus.connected) {
    return (
      <div className="card" style={{ maxWidth: '600px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div style={{ width: '64px', height: '64px', background: '#1877F2', borderRadius: '50%', color: '#fff', fontSize: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px auto' }}>
            📘
          </div>
          <h2 style={{ margin: '0 0 8px 0', fontSize: '20px', color: 'var(--text)' }}>Meta Hesabınız Bağlı</h2>
          <p style={{ margin: 0, color: 'var(--text-muted)' }}>Reklam verileriniz ve lead formlarınız sistemle senkronize ediliyor.</p>
        </div>

        <div style={{ background: 'rgba(255,255,255,0.02)', borderRadius: 'var(--radius)', padding: '16px', marginBottom: '24px', border: '1px solid var(--border)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px', borderBottom: '1px solid var(--border)', paddingBottom: '12px' }}>
            <span style={{ color: 'var(--text-muted)', fontWeight: '500' }}>Hesap Adı:</span>
            <span style={{ color: 'var(--text)', fontWeight: '600' }}>{connectionStatus.account_name || '-'}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px', borderBottom: '1px solid var(--border)', paddingBottom: '12px' }}>
            <span style={{ color: 'var(--text-muted)', fontWeight: '500' }}>Reklam Hesabı ID:</span>
            <span style={{ color: 'var(--text)', fontWeight: '600' }}>{connectionStatus.ad_account_id}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px', borderBottom: '1px solid var(--border)', paddingBottom: '12px' }}>
            <span style={{ color: 'var(--text-muted)', fontWeight: '500' }}>Son Senkronizasyon:</span>
            <span style={{ color: 'var(--text)', fontWeight: '600' }}>{connectionStatus.last_synced_at ? new Date(connectionStatus.last_synced_at).toLocaleString('tr-TR') : 'Henüz yapılmadı'}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ color: 'var(--text-muted)', fontWeight: '500' }}>Facebook Page ID:</span>
            {editingPageId ? (
              <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                <input
                  type="text"
                  className="input"
                  value={pageIdInput}
                  onChange={e => setPageIdInput(e.target.value)}
                  style={{ width: '160px', padding: '4px 8px', fontSize: '13px' }}
                  placeholder="Örn: 123456789012345"
                  autoFocus
                />
                <button onClick={savePageId} disabled={savingPageId} className="btn btn-success btn-sm" style={{ padding: '4px 10px', fontSize: '12px' }}>
                  {savingPageId ? '...' : 'Kaydet'}
                </button>
                <button onClick={() => setEditingPageId(false)} className="btn btn-ghost btn-sm" style={{ padding: '4px 10px', fontSize: '12px' }}>Vazgeç</button>
              </div>
            ) : (
              <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {connectionStatus.page_id ? (
                  <span style={{ color: 'var(--text)', fontWeight: '600' }}>{connectionStatus.page_id}</span>
                ) : (
                  <span style={{ color: '#F59E0B', fontWeight: '600', fontSize: '12px' }}>⚠ Ayarlanmamış (lead'ler gelmez)</span>
                )}
                <button onClick={startEditPageId} className="btn btn-ghost btn-sm" style={{ padding: '2px 8px', fontSize: '12px' }}>Düzenle</button>
              </span>
            )}
          </div>
        </div>

        {connectionStatus.last_sync_error && (
          <div style={{ background: 'rgba(239, 68, 68, 0.08)', border: '1px solid rgba(239, 68, 68, 0.35)', borderRadius: 'var(--radius)', padding: '14px 16px', marginBottom: '24px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '4px' }}>
              <span style={{ fontWeight: '700', color: '#EF4444', fontSize: '13px' }}>⚠ Son Senkronizasyon Hatası</span>
              {connectionStatus.last_sync_error_at && (
                <span style={{ fontSize: '11px', color: 'var(--text-muted)' }}>{new Date(connectionStatus.last_sync_error_at).toLocaleString('tr-TR')}</span>
              )}
            </div>
            <p style={{ margin: 0, fontSize: '13px', color: 'var(--text)', wordBreak: 'break-word' }}>{connectionStatus.last_sync_error}</p>
            <p style={{ margin: '6px 0 0', fontSize: '11px', color: 'var(--text-muted)' }}>Bir sonraki başarılı senkronizasyonda bu uyarı otomatik kaybolur.</p>
          </div>
        )}

        <div style={{ marginBottom: '32px' }}>
          <h4 style={{ margin: '0 0 8px 0', fontSize: '14px', color: 'var(--text)' }}>Leadads Webhook URL</h4>
          <p style={{ fontSize: '13px', color: 'var(--text-muted)', margin: '0 0 8px 0' }}>Meta App ayarlarından Webhook kurulumu için bu URL'yi kullanın. Verify Token: <code>ritsa_meta_verify_token</code></p>
          <div style={{ display: 'flex', gap: '8px' }}>
            <input type="text" readOnly value={`${window.location.origin}/api/meta/webhook`} className="input" style={{ flex: 1 }} />
            <button onClick={copyWebhook} className="btn btn-secondary">Kopyala</button>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            onClick={handleSync}
            disabled={syncing}
            className="btn btn-success"
            style={{ flex: 1 }}
          >
            {syncing ? 'Senkronize ediliyor...' : 'Şimdi Senkronize Et'}
          </button>
          <button
            onClick={handleDisconnect}
            disabled={loading}
            className="btn btn-danger"
            style={{ flex: 1 }}
          >
            Bağlantıyı Kes
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', gap: '24px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
      <div className="card" style={{ flex: '1 1 400px' }}>
        <h2 style={{ margin: '0 0 8px 0', fontSize: '20px', color: 'var(--text)' }}>Meta Business'a Bağlanın</h2>
        <p style={{ color: 'var(--text-muted)', marginBottom: '24px', fontSize: '14px', lineHeight: '1.5' }}>
          Reklam verilerinizi CRM içerisinde görebilmek için Meta Business üzerinden bir "System User Access Token" oluşturmalı ve reklam hesabı ID'nizi girmelisiniz.
        </p>

        <form onSubmit={handleConnect}>
          <div className="form-group">
            <label className="form-label">Ad Account ID (Zorunlu)</label>
            <input
              type="text"
              className="input"
              placeholder="Örn: 123456789012345"
              value={formData.ad_account_id}
              onChange={e => setFormData({ ...formData, ad_account_id: e.target.value })}
              required
            />
            <span className="form-helper">Başına act_ koymanıza gerek yoktur, sadece rakamlar.</span>
          </div>

          <div className="form-group">
            <label className="form-label">System User Access Token (Zorunlu)</label>
            <textarea
              className="textarea"
              placeholder="EAAAA..."
              value={formData.access_token}
              onChange={e => setFormData({ ...formData, access_token: e.target.value })}
              style={{ fontFamily: 'var(--font-mono, monospace)' }}
              required
            />
          </div>

          <div style={{ display: 'flex', gap: '16px' }}>
            <div className="form-group" style={{ flex: 1 }}>
              <label className="form-label">Hesap Adı (İsteğe Bağlı)</label>
              <input
                type="text"
                className="input"
                placeholder="Örn: Merkez Şube Ads"
                value={formData.account_name}
                onChange={e => setFormData({ ...formData, account_name: e.target.value })}
              />
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label className="form-label">Facebook Page ID (İsteğe Bağlı)</label>
              <input
                type="text"
                className="input"
                placeholder="Sadece Lead Ads için gerekli"
                value={formData.page_id}
                onChange={e => setFormData({ ...formData, page_id: e.target.value })}
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn btn-primary"
            style={{ width: '100%' }}
          >
            {loading ? 'Bağlanıyor...' : 'Bağlantıyı Kur'}
          </button>
        </form>
      </div>

      <div className="card" style={{ flex: '0 1 300px' }}>
        <h3 style={{ margin: '0 0 16px 0', fontSize: '15px', color: 'var(--text)' }}>Nasıl Token Alırım?</h3>
        <ol style={{ paddingLeft: '16px', margin: 0, color: 'var(--text-muted)', fontSize: '13px', lineHeight: '1.6' }}>
          <li style={{ marginBottom: '8px' }}>business.facebook.com adresine gidin ve ayarları açın.</li>
          <li style={{ marginBottom: '8px' }}>Kullanıcılar &gt; Sistem Kullanıcıları sekmesine tıklayın.</li>
          <li style={{ marginBottom: '8px' }}>Yeni bir sistem kullanıcısı ekleyin ve Reklam Hesabınıza erişim izni verin.</li>
          <li style={{ marginBottom: '8px' }}>"Yeni Token Oluştur" butonuna tıklayın. <code>ads_read</code>, <code>leads_retrieval</code> ve <code>pages_manage_ads</code> yetkilerini seçin.</li>
          <li>Oluşturulan uzun token'ı kopyalayıp yandaki alana yapıştırın.</li>
        </ol>
      </div>
    </div>
  );
};

export default ConnectionTab;
